<template>
  <div class="root-container">
    <div class="container">
      <div class="illustration">
        <img src="public/images/certification.jpg" alt="" />
      </div>
      <p class="caption">ダウンロードして、自分で名前を入れてね！</p>
      <p class="footer-link">
        <a
          href="public/images/certification.pdf"
          class="base-button"
          target="_blank"
          v-on:click="tapSound()"
          >認定書をダウンロード</a
        >
        <br />
        <router-link to="/">クイズトップにもどる</router-link>
      </p>
    </div>
    <Copyright />
  </div>
</template>

<script>
export default {
  name: 'Certificate',
}
</script>

<style scoped lang="scss">
.caption {
  text-align: center;
  font-size: 15px;
  margin-top: 1em;
  padding-bottom: 0.5em;
}

.footer-link {
  text-align: center;
  .base-button {
    margin-bottom: 1em;
    padding: 1em;
  }
}
</style>
